module.exports = __webpack_public_path__ + "img/mergdata_thumbnail.3d9f5080.png";